ko.bindingHandlers.afterForeach = {
    update: function (element, valueAccessor, allBindingsAccessor) {
        var items = ko.utils.unwrapObservable(allBindingsAccessor().foreach),
            callback = valueAccessor();
        
        if (items && items.length > 0) {
            callback();
        }
    }
};